import { Body, Box } from '@hover/blueprint';
import React from 'react';
import {
  Layout,
  ContractorsLogoList,
  ReadyToSeePossibilities,
  NewsLetterBar,
} from '../../../v2/components/common';
import {
  InsuranceHero,
  HoverSaveTime,
  InsuranceMeasurements,
  InsuranceClaimsEstimation,
  InsuranceResolution,
  InsuranceCustomerQuote,
} from '../../../v2/components/insurance';

const Insurance: React.FC = () => (
  <Layout
    title="Insurance"
    description="HOVER transforms smartphone photos of any home to accurate measurements for every facet of the home. Perfect for Insurance Adjustors. No need to hand measure the property or use outdated aerial imagery that could lead to inaccurate estimates. Let policyholders capture photos of the damage."
    buttonType="CHAT_WITH_A_REP"
  >
    <InsuranceHero />
    <Box w="100%" mb={700}>
      <Body mx="auto" color="neutral.700" fontWeight={600}>
        Insurance partners that prefer HOVER
      </Body>
    </Box>
    <ContractorsLogoList mb={{ base: '80px', tablet: 1100 }} />
    <HoverSaveTime />
    <InsuranceMeasurements />
    <InsuranceClaimsEstimation />
    <InsuranceResolution />
    <ReadyToSeePossibilities
      body="Whether you’re an insurance partner, a small carrier, a national team,
            or somewhere in between, we can help."
    />
    <InsuranceCustomerQuote />
    <NewsLetterBar showForm showViewJobs={false} />
  </Layout>
);

export default Insurance;
